import React, { useEffect, useState } from "react";
import { getDocs, collection, query, orderBy } from "firebase/firestore";
import { db } from "../services/firebase";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const fmt = new Intl.NumberFormat("fr-FR", { style: "currency", currency: "XOF" });

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const qy = query(collection(db, "ordersWine"), orderBy("createdAt", "desc"));
        const snap = await getDocs(qy);
        const data = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        setOrders(data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  if (loading) return <div className="container py-4"><p>Chargement des commandes…</p></div>;

  return (
    <div className="container py-4">
      <h2>Mes commandes</h2>
      {orders.length === 0 ? (
        <p className="no-results">Aucune commande.</p>
      ) : (
        <div className="list-group">
          {orders.map((o) => (
            <div key={o.id} className="list-group-item">
              <div className="d-flex justify-content-between">
                <div>
                  <h5>Commande #{o.id}</h5>
                  <div className="small text-muted">
                    {o.customer?.name} — {o.customer?.phone}
                  </div>
                  <div className="small">
                    <span className="badge text-bg-light border me-1">
                      {o.paymentMethod === "whatsapp"
                        ? "WhatsApp"
                        : o.paymentMethod === "paygate"
                        ? "Mobile (PayGate)"
                        : o.paymentMethod === "cod"
                        ? "À la livraison"
                        : (o.paymentMethod || "Méthode inconnue")}
                    </span>
                    <span className="badge text-bg-secondary">
                      {o.status || "—"}
                    </span>
                  </div>
                </div>
                <div className="text-end">
                  <div>{fmt.format(Number(o.total) || 0)}</div>
                  <div className="small text-muted">
                    {o.createdAt
                      ? new Date(
                          o.createdAt.seconds
                            ? o.createdAt.seconds * 1000
                            : o.createdAt
                        ).toLocaleString()
                      : ""}
                  </div>
                </div>
              </div>

              <div className="mt-2">
                {o.items?.map((it, idx) => (
                  <div key={`${it.id}-${idx}`} className="d-flex justify-content-between small">
                    <div>{it.name} × {it.qty}</div>
                    <div>{fmt.format((Number(it.price) || 0) * (it.qty || 0))}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
